import { useState, useRef, useEffect, useMemo } from "react";

import moment from "moment-timezone";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import Grid from "@mui/material/Grid";
//Backend access
import { getLiveviewHistoryImages } from 'api/bks';
import PropTypes from "prop-types";

import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import { PacmanLoader } from "react-spinners";
import LiveviewFeed from "nextus/Timelines/LiveviewTimeline/Feed";
import LiveviewSelects from "nextus/Charts/Selectors/Liveview";

import bksAPI from 'api/bks';
import { useQuery } from "@tanstack/react-query";

function wrapper(content) {
  return (
    <Grid container sx={{ height: 'calc(100% + 24px)' }}>
      <Grid item xs={12}>
        <SoftBox>
          {content}
        </SoftBox>
      </Grid>
    </Grid>
  )
}

// Images
function LiveviewTimeline({ uuid }) {

  const [endTime, setEndTime] = useState(moment().unix());
  const [startTime, setStartTime] = useState(moment().subtract(1, 'month').unix());
  const [currentTime, setCurrentTime] = useState(moment().unix());
  const [liveviewData, setLiveviewData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  bksAPI.loadToken(useAuth0());

  const currentLiveview = useQuery({
    queryKey: ['getLiveView', uuid],
    queryFn: async () => {
      return await bksAPI.getLiveView(uuid);
    }
  });

  useEffect(() => {
    async function getHistory() {
      // console.log(startTime, endTime);

      var data = await getLiveviewHistoryImages(uuid, startTime, endTime);
      // console.log(data);
      setLiveviewData(data);
      setIsLoading(false);
    }
    if (!isNaN(startTime) && !isNaN(endTime)) {
      getHistory();
    }
  }, [startTime, endTime]);


  if (currentLiveview.isLoading) {
    return wrapper("Loading...");
  }

  if (currentLiveview.error) {
    return wrapper("Error! " + currentLiveview.error.message);
  }

  const blob = new Blob([currentLiveview.data]);
  const current_liveview_url = URL.createObjectURL(blob);

  return (
    wrapper(
      <LiveviewFeed {...{ uuid, currentTime, setCurrentTime, startTime, setStartTime, endTime, setEndTime, liveviewData, isLoading, current_liveview_url }} />
    )
  );
}

// Typechecking props for the LiveviewTimeline
LiveviewTimeline.propTypes = {
  uuid: PropTypes.string
};


export default LiveviewTimeline;